// extracted by mini-css-extract-plugin
module.exports = {"container":"fullClickable_container__cZAyD","element":"fullClickable_element__sS1MS"};